const Helpers = {
	namespaced: true,

	state: {},
	mutations: {},
	actions: {
		revokeObjectURL: ({ commit }, payload) => {
			URL.revokeObjectURL(payload);
		},
	},
	getters: {},
};

export default Helpers;
